import { Divider, HStack, Spacer, Text, VStack } from "@chakra-ui/react";
import React, { memo, useMemo } from "react";
import colors from "app/colors";
import { useDistributionGroups } from "modules/providers/distribution-groups-provider";
import DistributionGroupName from "modules/_shared/distribution-group-name";
import DistributionGroupTooltip from "modules/_shared/distribution-group-tooltip";
import { sortByName } from "modules/utils/Functions";
import ToggleDistributionGroupInboxButton from "modules/drawers/components/user-profile/toggle-distribution-group-inbox-button";
import { useAuth } from "modules/providers/auth-provider";

const MeDistributionGroups = () => {
  const { me } = useAuth();
  const { distributionGroups } = useDistributionGroups();

  const distributionGroupList = useMemo(
    () =>
      me
        ? distributionGroups
            .filter((obj) => obj.userIdList.includes(me.id))
            .sort(sortByName)
        : [],
    [me, distributionGroups],
  );

  return (
    <VStack w="full" alignItems="flex-start">
      {distributionGroupList.map((distributionGroup) => (
        <React.Fragment key={distributionGroup.id}>
          <HStack w="full">
            <DistributionGroupTooltip id={distributionGroup.id}>
              <Text
                color={
                  distributionGroup.active ? colors.blue : colors.grayPrimary
                }
              >
                <DistributionGroupName
                  distributionGroupId={distributionGroup.id}
                />
              </Text>
            </DistributionGroupTooltip>
            <Spacer />
            <ToggleDistributionGroupInboxButton
              distributionGroup={distributionGroup}
            />
          </HStack>
          <Divider />
        </React.Fragment>
      ))}
    </VStack>
  );
};

export default memo(MeDistributionGroups);
